import React from "react"
import ReactLoading from "react-loading";
import * as style from "./Loading.module.scss"

const Loading = ({ text }) => {

    return (
        <div className={style.loading}>
            <ReactLoading type="bubbles" color="#5A3A9C"
                height={100} width={100} />
            <div className={style.text}>{text ? text : "Loading..."}</div>
        </div>
    )
}

export default Loading